/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import { useParams } from "react-router-dom";
import projectImg from "../../../assets-user/projectImg.png";
import {
  Amenities,
  MapEmbed,
} from "../../../components/admin/common/details-components";
import ContactForm from "../../../components/public/userCommon/ContactForm";
import ContactUs from "../../../components/public/userCommon/ContactUs";
import TopDevelopers from "../../../components/public/userCommon/TopDevelopers";
import FAQSection from "../../../components/public/userLogin/FAQSection";
import NewProjects from "../../../components/public/userResidentialPropertiesDetails/NewProjects";
import PropertiesForSale from "../../../components/public/userResidentialPropertiesDetails/PropertiesForSale";
import PropertyCard from "../../../components/public/userResidentialPropertiesDetails/PropertyCard";
import PropertyDetails from "../../../components/public/userResidentialPropertiesDetails/PropertyDetails";
import api from "../../../configs/api";
import { formatPrettyAddress } from "../../../utils/helpers";
import AmenitiesProject from "../../../components/public/userProjectDetails/AmenitiesProject";

const AboutLaCasa = ({ property }) => {
  if (!property) {
    return (
      <div className="text-center py-10 text-gray-500">
        No property data available.
      </div>
    );
  }

  const { description } = property;

  return (
    <div className="py-6 md:py-8 ">
      <div
        data-aos="fade-up"
        data-aos-duration="800"
        className="bg-white rounded-lg shadow-sm p-4 sm:p-6 md:p-8 mx-auto w-full border"
      >
        <h2 className="font-poppins font-medium tracking-[0.01em] leading-[150%] text-lg sm:text-xl md:text-2xl lg:text-3xl text-[#031722]">
          About {property?.title}
        </h2>

        <div
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-duration="700"
          className="border-t-2 border-gray-200 mt-3 sm:mt-4"
        ></div>

        {/* Description Text */}
        <div className="mt-3 sm:mt-4 space-y-3 sm:space-y-4 font-poppins font-normal text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] tracking-wider text-[#858585] text-justify w-full sm:w-[95%] md:w-[90%] lg:w-full">
          {description ? (
            <p className="font-poppins font-normal tracking-[0.01em] leading-[150%] text-sm sm:text-base xl:text-[16px] mb-3 sm:mb-4 text-[#858585]">
              {description}
            </p>
          ) : (
            <>
              <div className="bg-[#f9fafb] border border-gray-200 rounded-lg p-5 sm:p-6 md:p-7 text-center">
                <p className="text-[#999] text-base sm:text-lg font-medium">
                  No description available for this project.
                </p>
                <p className="text-[#777] text-sm sm:text-base mt-2">
                  The project details will be updated soon.
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const AboutProjects = () => {
  return (
    <div className="w-full py-10">
      <div className="bg-white mx-auto p-4 sm:p-6 lg:p-8  rounded-lg border">
        {/* Header Section */}
        <div
          className="flex flex-row justify-between items-start sm:items-center gap-4 mb-6 sm:mb-8"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <h2 className="font-inter font-medium text-lg sm:text-xl md:text-2xl lg:text-3xl leading-[150%] tracking-[0.01em] text-[#222222] mb-1 sm:mb-2">
            About Project
          </h2>

          <button
            className="flex items-center gap-2 font-poppins font-medium text-sm sm:text-base md:text-lg leading-[150%] tracking-[0.01em] text-[#DC2200] text-center"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            Explore Project
            <FaArrowRight className="text-xs sm:text-sm" />
          </button>
        </div>

        {/* Project Info Card */}
        <div className="rounded-3xl">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6 lg:gap-8">
            {/* Project Logo Container */}
            <div
              className="flex-shrink-0 w-full sm:w-auto"
              data-aos="zoom-in"
              data-aos-delay="300"
            >
              <div className="w-32 sm:w-36  h-32 sm:h-36  bg-white rounded-3xl shadow-md flex items-center justify-center p-3 sm:p-4 mx-auto sm:mx-0">
                <img
                  src={projectImg}
                  alt="Covenants Developers Logo"
                  className="w-full h-full object-contain rounded-lg"
                />
              </div>
            </div>

            {/* Project Details */}
            <div
              className="flex-1 text-center sm:text-left w-full"
              data-aos="fade-right"
              data-aos-delay="400"
            >
              <h3 className="font-inter font-medium text-base sm:text-lg md:text-xl lg:text-[22px] leading-[150%] tracking-[0.01em] text-[#222222] mb-2">
                Covenants Developers
              </h3>
              <p className="font-inter font-normal text-sm sm:text-base md:text-lg lg:text-[18px] leading-[150%] tracking-[0.01em] text-[#98917F]">
                by Covenants
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const DetailsResidentialProperty = () => {
  const { id } = useParams();
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // fetch data
  const fetchPropertyById = async () => {
    try {
      console.log("Fetching property with ID:===>", id);
      setLoading(true);
      const response = await api.get(`/properties/${id}`);
      // console.log("API Response:===>", response.data);

      if (response.data?.data) {
        setProperty(response.data.data);
      } else {
        setError("Property data not found.");
      }
    } catch (err) {
      console.error("Error fetching property details:", err);
      setError("Failed to fetch property details.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchPropertyById();
  }, [id]);

  //  Handle loading state
  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen text-gray-600">
        Loading property details...
      </div>
    );
  }

  //  Handle error state
  if (error) {
    return (
      <div className="flex justify-center items-center min-h-screen text-red-500">
        {error}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-4 px-4 sm:px-6 lg:px-8 xl:px-10 py-4 sm:py-6 lg:py-8  gap-4 sm:gap-6 md:gap-8  overflow-hidden">
      <div className="col-span-1 lg:col-span-3">
        <PropertyCard property={property} />
        <AboutLaCasa property={property} />
        <PropertyDetails property={property} />
        <Amenities amenities={property?.property?.amenities || []} />
        <div className="mt-4 sm:mt-6 md:mt-8 ">
          <MapEmbed
            className="h-[30rem]"
            coordinates={property?.location?.coordinates}
            address={formatPrettyAddress(property?.location)}
          />{" "}
        </div>
        <AboutProjects project={property?.property} />
        <PropertiesForSale property={property} />
        <NewProjects property={property} />
        <TopDevelopers title="Builders in Kalinganagar" />
        <FAQSection />
      </div>

      {/* Sidebar Section */}
      <div className="col-span-1 flex flex-col gap-4 sm:gap-6 md:gap-8 ">
        <ContactUs />
        <ContactForm />
      </div>
    </div>
  );
};

export default DetailsResidentialProperty;
